// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"styles_checkboxGroup__EJ0Ci","label":"styles_label__WoYdS","checkboxGroupItems":"styles_checkboxGroupItems__MlaIJ"};